<template>
  <v-btn
    class="mbtn font-weight-regular"
    prepend-icon="ct:arrow-left"
    @click="appraisalBuyoutStep -= 1"
  >
    {{ t("buyout.appraisal.go_back") }}
  </v-btn>
  <div class="app__title app__title--h3">
    {{ `${t("buyout.appraisal.choose_brand")} ${selectedDeviceType?.name_second_case} ${isNewDeviceProcess ? t("static.banners.for_buyout") : ''}` }}
  </div>
  <v-progress-circular v-if="loadingManufacturers" />
  <div
    v-else
    class="buyout__cards buyout__cards--manufacturer"
  >
    <div
      v-for="availableManufacturer in availableManufacturers"
      :key="availableManufacturer.id"
      :class="['bCard', selectedManufacturer === availableManufacturer ? 'is-selected' : '', 'text-center cursor-pointer']"
      @click="selectManufacturer(availableManufacturer)"
    >
      <img :src="buildImageUrl(availableManufacturer.logo)" class="img-responsive">
      <div class="app__title app__title--h6 font-poppins">
        {{ availableManufacturer.name }}
      </div>
    </div>
  </div>
  <v-dialog v-model="dialog" content-class="popup aScroll">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        class="mbtn mbtn--trans mbtn--multiline"
        size="x-large"
      >
        {{ `${t("buyout.common.you_havent_found_brand")} ${getTranslation} ${selectedDeviceType?.name_second_case}` }}?
      </v-btn>
    </template>
    <nuxt-link
      class="popup__close cursor-pointer"
      @click="dialog = !dialog"
    >
      <v-icon icon="ct:cross" size="x-small" />
    </nuxt-link>
    <auth-contact-form
      :subject="(`${t('buyout.common.didnt_find_brand')} ${getTranslation} ${selectedDeviceType?.name_second_case}?`)"
      @close-dialog="dialog = false"
    />
  </v-dialog>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
const { buildImageUrl } = useUtils();
const { t } = useI18n();

const buyoutStore = useBuyoutStore();
const bonusPartnerWithManufacturerBuyoutStore = useBonusPartnerWithManufacturerBuyoutStore();

const {
  selectedDeviceType,
  selectedManufacturer,
  availableManufacturers,
  appraisalBuyoutStep,
  loadingManufacturers
} = storeToRefs(buyoutStore);

const componentProps = withDefaults(defineProps<{
  isNewDeviceProcess?: boolean
}>(), {
  isNewDeviceProcess: false
});

if (!availableManufacturers?.value?.length) {
  buyoutStore.loadAvailableManufacturers();
}
const getTranslation = computed<string>(() => {
  if (selectedDeviceType?.value && (["telefony", "tablety", "notebooky", "foto", "objektivy", "reproduktory"].includes(selectedDeviceType.value.seo_name))) {
    return t("buyout.appraisal.your_first");
  }
  if (selectedDeviceType?.value && selectedDeviceType.value?.seo_name === "chytre-hodinky") {
    return t("buyout.appraisal.your_second");
  }
  return t("buyout.appraisal.your_third");
});

async function selectManufacturer (manufacturer: BuyoutDeviceManufacturer) {
  if (selectedManufacturer.value !== manufacturer) {
    selectedManufacturer.value = manufacturer;
    buyoutStore.resetMetaMaster();
    if(componentProps.isNewDeviceProcess) {
      await bonusPartnerWithManufacturerBuyoutStore.changeURLNewDevice();
    } else {
      await buyoutStore.changeURL();
    }
  }
  appraisalBuyoutStep.value += 1;
}

const dialog = ref<boolean>(false);
</script>
